import { GIFCON_APP_API } from '@/shared/config/api';
import { isHttpUrl } from './url';

export const NO_IMAGE = '/images/no_image.jpg';

const RELAYS: Record<string, string> = {
  'http://imgt.multicon.co.kr:9999': '/vendor-images/multicon',
};

export function safeSrc(url: string | null | undefined): string {
  if (!url || !isHttpUrl(url)) return NO_IMAGE;
  const { origin, pathname, search } = new URL(url);
  const relay = RELAYS[origin];
  return relay ? `${relay}${pathname}${search}` : url;
}

export function couponImageSrc(token: string): string {
  return `${GIFCON_APP_API}/coupons/${encodeURIComponent(token)}/image`;
}
